import React, { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserData } from "../Functions/firebaseFunction";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  return (
    <UserContext.Provider value={{ userData, setUserData, loading, setLoading, error, setError }}>
      {children}
    </UserContext.Provider>
  );
};

export const UserDataFetcher = () => {
  const navigate = useNavigate();
  const { setUserData, setLoading, setError } = useContext(UserContext);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user = await UserData();
        setUserData(user);
        setError(null);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setError(error.message || "Failed to fetch user data");
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
  }, [navigate, setUserData, setLoading, setError]);

  return null;
};